
import React, { createContext, useState, useContext } from "react";

const EnergiaHvacContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaHvac_id, setEnergiaHvac_id] = useState();

  return (
    <EnergiaHvacContext.Provider value={{ energiaHvac_id, setEnergiaHvac_id }} >
      {children}
    </EnergiaHvacContext.Provider>
  );
}

export function useEnergiaHvacContext() {
  const context = useContext(EnergiaHvacContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaHvac_id, setEnergiaHvac_id } = context;
  return { energiaHvac_id, setEnergiaHvac_id };
}

